import styled from 'styled-components';
import { Card } from '@perch-labs/shrike';

export const CardContent = styled(Card.Content)<StyleProps>`
  background-color: ${props => props.theme.colors.background[props.variant]};
`;
